import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('CheckboxIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon_checkbox" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <path className="background" d="M15.61,18H2.39A2.39,2.39,0,0,1,0,15.61V2.39A2.39,2.39,0,0,1,2.39,0H15.61A2.39,2.39,0,0,1,18,2.39V15.61A2.39,2.39,0,0,1,15.61,18Z"/>
        <rect x="-3" y="-3" width="24" height="24" style="fill:none;"/>
        <path className="border" d="M15.61,18H2.39A2.39,2.39,0,0,1,0,15.61V2.39A2.39,2.39,0,0,1,2.39,0H15.61A2.39,2.39,0,0,1,18,2.39V15.61A2.39,2.39,0,0,1,15.61,18ZM3.22,2A1.22,1.22,0,0,0,2,3.22V14.78A1.22,1.22,0,0,0,3.22,16H14.78A1.22,1.22,0,0,0,16,14.78V3.22A1.22,1.22,0,0,0,14.78,2Z"/>
        <polygon className="foreground" points="7 14 2 9.19 3.4 7.85 7 11.31 14.6 4 16 5.35 7 14"/>
      </svg>
    ), el);
  });
};
